import React, { useCallback, useEffect, useState } from 'react';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { getAssets, getAssetsCSV, getSignedImageUrl } from '../../../services/asset.service';
import { getDivisionAdditionalList } from '../../../services/user.service';
import * as CryptoJS from "crypto-js";
import './AssetInfo.css';
import './AssetList.css';
import { Box, Pagination } from '@mui/material';
import Select from "react-select";
import { Parser } from "json2csv";
import FromFieldDate from "../../../atoms/FromFieldDate";

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
};

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const AssetList = () => {

    /* ─── Columns (identical backend logic – only renderCell class names updated) ─── */
    const columns = [
        { field: "sl_no", hideable: true, hide: true, editable: false, headerName: "Sl No", width: 50 },
        
        {
            field: 'tag', editable: false, hide: false, headerName: 'TAG', width: 280,
            renderCell: (params) => {
                let encryptedTag = CryptoJS.AES.encrypt(JSON.stringify({ 'tag': params.value }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-tag-link" href={`/asset-details?tag=${encryptedTag}`}>{params.value}</a>;
            }
        },
        {
            field: 'viewPLC', editable: false, hide: false, headerName: 'View PLC', width: 120,
            renderCell: (params) => {
                let encryptedTag = CryptoJS.AES.encrypt(JSON.stringify({ 'tag': params.value }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                return <a className="al-cell-plc-link" href={`/plcdetails?tag=${encryptedTag}`}><i className="bi bi-eye" /> PLC</a>;
            }
        },
        { field: "parent_tag", hideable: true, hide: false, editable: true, headerName: "Parent TAG", width: 280 },
        { field: "aan_no", hideable: true, hide: false, editable: false, headerName: "AAN No.", width: 220 },
        { field: "batch_id", hideable: true, hide: false, editable: true, headerName: "Batch ID", width: 280 },
        { field: "year_of_addition", hideable: true, hide: false, editable: true, headerName: "Year of Addition", width: 130 },
        { field: "type_of_addition", editable: true, hide: false, headerName: "Type of Addition", width: 280 },
        { field: "project_marking", editable: true, hide: true, headerName: "Project Marking", width: 180 },
        { field: "po_no", editable: true, hide: true, headerName: "PO No (If Any)", width: 180 },
        { field: "supplier_code", editable: true, hide: true, headerName: "Supplier Code (if Any)", width: 180 },
        { field: "supplier_name", editable: true, hide: false, headerName: "Name of the Supplier", width: 280 },
        { field: "invoice_no", editable: true, hide: false, headerName: "Invoice No", width: 180 },
        { field: "invoice_date", editable: true, hide: false, headerName: "Invoice Date", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.invoice_date)}</p> },
        { field: "boe_no", hideable: true, hide: true, editable: true, headerName: "Bill of Entry No", width: 180 },
        { field: "boe_date", editable: true, hide: true, headerName: "Date of BOE", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.boe_date)}</p> },
        { field: "shipping_awb_no", hideable: true, hide: true, editable: true, headerName: "Shipping / AWB No", width: 180 },
        { field: "shipping_awb_date", editable: true, hide: true, headerName: "Date of Shipping/AWB", width: 180, renderCell: (params) => <p>{getFormatedDate(params.row.shipping_awb_date)}</p> },
        { field: "accounting_voucher_no", editable: false, hide: true, headerName: "Accounting voucher no", width: 180 },
        { field: "internal_approval_no", editable: false, hide: true, headerName: "Internal approval no", width: 180 },
        { field: "cost_center_code", editable: false, hide: true, headerName: "Cost center code", width: 130 },
        { field: "cost_center_name", editable: false, hide: true, headerName: "Cost center name", width: 130 },
        { field: "invoice_currency", editable: false, hide: false, headerName: "Invoice Currency", width: 130 },
        { field: "exchange_rate", editable: false, hide: true, headerName: "Exchange Rate", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.exchange_rate)}</p> },
        { field: "invoice_value_fx", editable: false, hide: true, headerName: "Basic Cost p.u in Fx", width: 180, renderCell: (params) => <p>{getFormatedDate(params.row.invoice_value_fx)}</p> },
        { field: "invoice_value_inr", editable: false, hide: true, headerName: "Basic Cost p.u in INR", width: 180, renderCell: (params) => <p>{getFormatedDate(params.row.invoice_value_inr)}</p> },
        { field: "forwarding_and_insurance", editable: false, hide: true, headerName: "Forwarding & Insurance", width: 180, renderCell: (params) => <p>{getFormatedDate(params.row.forwarding_and_insurance)}</p> },
        { field: "installation", editable: false, hide: true, headerName: "Installation", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.installation)}</p> },
        { field: "errection", editable: false, hide: true, headerName: "Erection", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.errection)}</p> },
        { field: "customs", editable: false, hide: true, headerName: "Customs", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.customs)}</p> },
        { field: "cgst", editable: false, hide: true, headerName: "CGST", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.cgst)}</p> },
        { field: "sgst", editable: false, hide: true, headerName: "SGST", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.sgst)}</p> },
        { field: "igst", editable: false, hide: true, headerName: "IGST", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.igst)}</p> },
        { field: "other_taxes", editable: false, hide: true, headerName: "Other Taxes", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.other_taxes)}</p> },
        { field: "total_tax", editable: false, hide: true, headerName: "Total Tax p.u", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.total_tax)}</p> },
        { field: "value_of_asset", editable: false, hide: false, headerName: "Total cost with tax p.u", width: 200, renderCell: (params) => <p>{params.row.value_of_asset}</p> },
        { field: "qty", editable: false, hide: false, headerName: "Qty", width: 80, renderCell: (params) => <p>{params.row.qty}</p> },
        { field: "total_cost_without_tax", editable: false, hide: false, headerName: "Total Cost Without Tax p.u", width: 220, renderCell: (params) => <p>{parseFloat(params.row.total_cost_without_tax).toFixed(2)}</p> },
        { field: "tax", editable: false, hide: true, headerName: "Tax", width: 130, renderCell: (params) => <p>{getFormatedDate(params.row.tax)}</p> },
        { field: "asset_name", editable: false, hide: false, headerName: "Name of the Asset (as per Invoice)", width: 250 },
        { field: "asset_description", editable: false, hide: false, headerName: "Detailed Description of the Asset", width: 250 },
        { field: "asset_serial_no", editable: false, hide: true, headerName: "Unique Sl No of the Asset", width: 200 },
        { field: "manufacturer", editable: false, hide: true, headerName: "Make / Manufacturer", width: 180 },
        { field: "model_no", editable: false, hide: true, headerName: "Model No", width: 130 },
        { field: "part_no", editable: false, hide: true, headerName: "Part No", width: 130 },
        { field: "nature_of_presence", editable: true, hide: false, headerName: "Nature of Presence", width: 180 },
        { field: "nature_of_addition", editable: true, hide: false, headerName: "Nature of Addition", width: 180 },
        { field: "principal_asset_tag", editable: true, hide: false, headerName: "Principal Asset to which Cost is Added", width: 280 },
        { field: "tag_name", editable: false, hide: true, headerName: "Asset TAG Name", width: 280 },
        { field: "tag_division", editable: false, hide: true, headerName: "Asset TAG Branch", width: 180 },
        { field: "department_name", editable: true, hide: false, headerName: "Control Department Name", width: 180 },
        { field: "unit_of_measure", editable: false, hide: false, headerName: "Unit of Measure", width: 130 },
        { field: "security_seal_date", editable: false, hide: true, headerName: "Security Seal Date", width: 180, renderCell: (params) => <p>{getFormatedDate(params.row.security_seal_date)}</p> },
        { field: "comp_ref_no", editable: false, hide: true, headerName: "Comp Ref. No.", width: 230 },
        {
            field: "thumbnail", editable: false, hide: false, headerName: "Thumbnail", width: 90,
            renderCell: (params) => (
                <div>
                    {params.row.asset_image && params.row.asset_image ? (
                        <img
                            onClick={() => handlePreviewImage(params.row.asset_image_url, params.row.asset_image, "Front")}
                            src={params.row.asset_thumbnail}
                            className="al-cell-thumb"
                            alt="asset"
                        />
                    ) : (
                        <span className="al-cell-no-img"><i className="bi bi-image" /> No Image</span>
                    )}
                </div>
            )
        },
        {
            field: "created_at", editable: false, hide: false, headerName: "Created Date", width: 130,
            renderCell: (params) => <p>{getFormatedDate(params.row.created_at)}</p>
        },
    ];

    const CustomLoader = () => (
        <GridOverlay>
            <CircularProgress color="primary" size={30} />
        </GridOverlay>
    );

    /* ─── All State (identical to original) ─── */
    const [items, setItems] = useState([]);
    const [itemsCSV, setItemsCSV] = useState([]);
    const [searchTag, setSearchTag] = useState('');
    const [ErrSearchTag, setErrSearchTag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [exloading, setExLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [filterCriteria, setFilterCriteria] = useState('');
    const [ErrFilterCriteria, setErrFilterCriteria] = useState(false);
    const [filterOperator, setFilterOperator] = useState('');
    const [ErrFilterOperator, setErrFilterOperator] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [ErrStartDate, setErrStartDate] = useState(false);
    const [endDate, setEndDate] = useState('');
    const [ErrEndDate, setErrEndDate] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [head_title, setHeadTitle] = useState('');
    const [imageName, setImageName] = useState('');
    const [otherDivisions, setOtherDivisions] = useState([]);
    const [selectedOtherDivisions, setSelectedOtherDivisions] = useState([]);

    /* ─── All Handlers (identical logic to original) ─── */
    const handlePreviewImage = async (imageId, imageName, headtitle) => {
        try {
            setShowModal(true);
            setHeadTitle(headtitle);
            setImageName(imageName);
            setPreviewImage(imageId);
        } catch (error) {
            console.error('Error previewing image:', error);
        }
    };

    const handleDownloadFile = async (imageId, id) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'fileKey': imageId },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData };
        try {
            const res = await getSignedImageUrl(oData1);
            if (res?.data?.url) {
                const url = res.data.url;
                const response = await fetch(url);
                const blob = await response.blob();
                const filename = imageId.substring(imageId.lastIndexOf('/') + 1);
                const downloadUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(downloadUrl);
            }
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;

    const fetchAssets = useCallback(async (currentPage = page, currentPageSize = pageSize) => {
        setLoading(true);
        const offset = calculateOffset(currentPage, currentPageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: { 'offset': offset, 'pageSize': currentPageSize },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getAssets({ token: encryptedData });
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchAssets1 = async (currentPage = page, currentPageSize = pageSize) => {
        setLoading(true);
        const offset = calculateOffset(currentPage, currentPageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset, 'pageSize': currentPageSize,
                'searchTag': searchTag, 'filterCriteria': filterCriteria,
                'filterOperator': filterOperator, 'startDate': getFormatedDate(startDate),
                'endDate': getFormatedDate(endDate), 'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const res = await getAssets({ token: encryptedData });
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching assets:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAssetsCSV = useCallback(async () => {
        setExLoading(true);
        const offset = calculateOffset(page, pageSize);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: {
                'offset': offset, 'pageSize': pageSize, 'searchTag': searchTag,
                'filterCriteria': filterCriteria, 'filterOperator': filterOperator,
                'startDate': getFormatedDate(startDate), 'endDate': getFormatedDate(endDate),
                'other_division': otherDivisionIds,
            },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        try {
            const resCSV = await getAssetsCSV({ token: encryptedData });
            if (resCSV?.data?.data?.length) setItemsCSV(resCSV.data.data);
        } catch (error) {
            console.error('Error fetching assets CSV:', error);
        } finally {
            setExLoading(false);
        }
    }, [filterCriteria, filterOperator, searchTag, startDate, endDate, page, pageSize]);

    useEffect(() => { fetchAssets(page, pageSize); }, []);
    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            param_data: { 'other_division_ids': sessionStorage.getItem('LoggedInOtherDivisionIds') },
            authToken: sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        getDivisionAdditionalList({ 'token': EncryptData }).then(res => {
            if (res?.data?.data?.length) setOtherDivisions(res.data.data);
        });
    }, []);
    useEffect(() => { if (itemsCSV.length > 0) generateCSV(); }, [itemsCSV]);

    const handlePageChange = (event, value) => {
        setPage(value);
        if (filterCriteria) fetchAssets1(value, pageSize);
        else fetchAssets(value, pageSize);
    };

    const totalPages = Math.ceil(totalItems / pageSize);
    const handleExportToCSV = async () => { await fetchAssetsCSV(); };

    const generateCSV = () => {
        try {
            const jsonData = itemsCSV.map(item => ({
                aan_no: item.aan_no || '', tag: item.tag || '', parent_tag: item.parent_tag || '',
                batch_id: item.batch_id || '',
                year_of_addition: item.year_of_addition || '', type_of_addition: item.type_of_addition || '',
                project_marking: item.project_marking || '', po_no: item.po_no || '',
                supplier_code: item.supplier_code || '', supplier_name: item.supplier_name || '',
                invoice_no: item.invoice_no || '', invoice_date: item.invoice_date ? getFormatedDate(item.invoice_date) : '',
                boe_no: item.boe_no || '', boe_date: item.boe_date ? getFormatedDate(item.boe_date) : '',
                shipping_awb_no: item.shipping_awb_no || '', shipping_awb_date: item.shipping_awb_date ? getFormatedDate(item.shipping_awb_date) : '',
                accounting_voucher_no: item.accounting_voucher_no || '', internal_approval_no: item.internal_approval_no || '',
                cost_center_code: item.cost_center_code || '', cost_center_name: item.cost_center_name || '',
                invoice_currency: item.invoice_currency || '', exchange_rate: item.exchange_rate || '',
                invoice_value_fx: item.invoice_value_fx || '', invoice_value_inr: item.invoice_value_inr || '',
                forwarding_and_insurance: item.forwarding_and_insurance || '', installation: item.installation || '',
                errection: item.errection || '', customs: item.customs || '', cgst: item.cgst || '',
                sgst: item.sgst || '', igst: item.igst || '', other_taxes: item.other_taxes || '',
                total_tax: item.total_tax || '', value_of_asset: item.value_of_asset || '',
                qty: item.qty || '', total_cost_without_tax: item.total_cost_without_tax || '',
                tax: item.tax || '', asset_name: item.asset_name || '', asset_description: item.asset_description || '',
                asset_serial_no: item.asset_serial_no || '', manufacturer: item.manufacturer || '',
                model_no: item.model_no || '', part_no: item.part_no || '',
                nature_of_presence: item.nature_of_presence || '', nature_of_addition: item.nature_of_addition || '',
                principal_asset_tag: item.principal_asset_tag || '', tag_name: item.tag_name || '',
                tag_division: item.tag_division || '', department_name: item.department_name || '',
                unit_of_measure: item.unit_of_measure || '', security_seal_date: item.security_seal_date ? getFormatedDate(item.security_seal_date) : '',
                comp_ref_no: item.comp_ref_no || '', created_at: item.created_at ? getFormatedDate(item.created_at) : '',
            }));
            const json2csvParser = new Parser();
            const csv = json2csvParser.parse(jsonData);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'All_Asset_List.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error exporting data to CSV:', error);
        }
    };

    const handleSearch = () => {
        let isValid = true;
        if (!filterCriteria) { setErrFilterCriteria('Please select a filter criteria'); isValid = false; } else setErrFilterCriteria('');
        if (filterCriteria !== 'created_at' && !filterOperator) { setErrFilterOperator('Please select a filter operator'); isValid = false; } else setErrFilterOperator('');
        if (!searchTag && filterCriteria != 'created_at') { setErrSearchTag('Please enter a search text'); isValid = false; } else setErrSearchTag('');
        if (!startDate && filterCriteria == 'created_at') { setErrStartDate('Please select start date'); isValid = false; } else setErrStartDate('');
        if (!endDate && filterCriteria == 'created_at') { setErrEndDate('Please select end date'); isValid = false; } else setErrEndDate('');
        if (isValid) { setPage(1); fetchAssets1(); }
    };

    const options = ["AAN Number", "TAG Number", "Year Of Addition", "Type of Addition", "PO Number", "Supplier Name", "Invoice Number", "Asset Name", "Make", "Model Number", "Asset Serial Number", "Part Number", "TAG Name", "Nature of Presence", "Date Range"];
    const values = ["aan_no", "tag", "year_of_addition", "type_of_addition", "po_no", "supplier_name", "invoice_no", "asset_name", "manufacturer", "model_no", "asset_serial_no", "part_no", "tag_name", "nature_of_presence", "created_at"];
    const combinedOptions = options.map((option, index) => ({ label: option, value: values[index] }));

    const handleSelectChange = (e) => {
        const selectedOption = combinedOptions.find(option => option.value === e.target.value);
        setFilterCriteria(selectedOption ? selectedOption.value : '');
        setErrFilterCriteria('');
    };

    const optionsFilter = ["Contains", "Equals", "Not Contains", "Not Equals", "Blank", "Non Blank"];
    const valuesFilter = ["LIKE", "=", "NOT LIKE", "!=", "IS NULL", "IS NOT NULL"];
    const combinedOptionsFilter = optionsFilter.map((option, index) => ({ label: option, value: valuesFilter[index] }));

    const handleOperatorChange = (e) => { setFilterOperator(e.target.value); setErrFilterOperator(''); };
    const handelSearchText = (e) => { setSearchTag(e.target.value); };

    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
        if (filterCriteria) fetchAssets1(1, value);
        else fetchAssets(1, value);
    };

    const otherDivisionOptions = otherDivisions.map(option => ({ value: option.id, label: option.division_name }));
    const handleOtherDivisions = (selectedOptions) => { setSelectedOtherDivisions(selectedOptions || []); };
    const otherDivisionIds = selectedOtherDivisions.map(option => option.value);

    /* ─── RENDER ─── */
    return (
        <div className="al-page" id="all-asset-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-collection-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">All Asset List</h5>
                        <p className="al-page-subtitle">Browse, search and export your complete asset inventory</p>
                    </div>
                </div>
                {!loading && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill" />
                        <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ FILTER PANEL ══ */}
            <div className="al-filter-card" id="al-filter-panel">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-funnel-fill" /> Search &amp; Filter
                    </span>
                </div>
                <div className="al-filter-card-body">

                    {/* Branch selector */}
                    {otherDivisionOptions.length > 0 && (
                        <div className="al-filter-row" id="al-branch-row">
                            <label className="al-filter-label">
                                <i className="bi bi-geo-alt-fill" /> Branch (Division)
                            </label>
                            <div className="al-filter-control-full">
                                <Select
                                    options={otherDivisionOptions}
                                    isMulti
                                    placeholder="Select one or more branches…"
                                    value={selectedOtherDivisions}
                                    onChange={handleOtherDivisions}
                                    classNamePrefix="al-select"
                                />
                            </div>
                        </div>
                    )}

                    {/* Criteria / Operator / Value */}
                    <div className="al-filter-grid" id="al-filter-grid">
                        <div className="al-filter-group">
                            <label className="al-filter-label">
                                Select Criteria <span className="al-required-star">*</span>
                            </label>
                            <select className="al-form-select" value={filterCriteria} onChange={handleSelectChange}>
                                <option value="" disabled>Select Filter Criteria</option>
                                {combinedOptions.map((opt, i) => (
                                    <option key={i} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            {ErrFilterCriteria && <span className="al-field-error"><i className="bi bi-exclamation-circle" /> {ErrFilterCriteria}</span>}
                        </div>

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group">
                                <label className="al-filter-label">
                                    Select Operator <span className="al-required-star">*</span>
                                </label>
                                <select className="al-form-select" value={filterOperator} onChange={handleOperatorChange}>
                                    <option value="" disabled>Select Operator</option>
                                    {combinedOptionsFilter.map((opt, i) => (
                                        <option key={i} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                                {ErrFilterOperator && <span className="al-field-error"><i className="bi bi-exclamation-circle" /> {ErrFilterOperator}</span>}
                            </div>
                        )}

                        {filterCriteria !== 'created_at' && (
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">
                                    Enter Criteria <span className="al-required-star">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="al-form-input"
                                    placeholder="Type search value…"
                                    inputValue={searchTag}
                                    onChange={handelSearchText}
                                />
                                {ErrSearchTag && <span className="al-field-error"><i className="bi bi-exclamation-circle" /> {ErrSearchTag}</span>}
                            </div>
                        )}
                    </div>

                    {/* Date range */}
                    {filterCriteria === 'created_at' && (
                        <div className="al-date-grid" id="al-date-grid">
                            <div className="al-filter-group">
                                <FromFieldDate label="Start Date" placeholder="Select Start Date"
                                    inputValue={startDate} setInputValue={setStartDate} setErrorMsg={ErrStartDate} />
                            </div>
                            <div className="al-filter-group">
                                <FromFieldDate label="End Date" placeholder="Select End Date"
                                    inputValue={endDate} setInputValue={setEndDate} setErrorMsg={ErrEndDate} />
                            </div>
                        </div>
                    )}

                    {/* Buttons */}
                    <div className="al-filter-actions" id="al-filter-actions">
                        <button className="al-btn al-btn-primary" id="al-search-btn" onClick={handleSearch}>
                            <i className="bi bi-search" /> Search Assets
                        </button>
                        <button className="al-btn al-btn-outline" id="al-export-btn" onClick={handleExportToCSV} disabled={loading}>
                            {exloading ? (
                                <><span className="al-dot" /><span className="al-dot" /><span className="al-dot" /> Exporting…</>
                            ) : (
                                <><i className="bi bi-file-earmark-arrow-down" /> Export All to CSV</>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table" /> Asset Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> of <strong>{totalItems.toLocaleString('en-IN')}</strong>
                        </span>
                    )}
                </div>

                <Box>
                    <DataGrid
                        rows={items}
                        getRowId={(row) => row.sl_no}
                        columns={columns}
                        autoHeight
                        className="al-data-grid"
                        components={{
                            LoadingOverlay: CustomLoader,
                            Pagination: () => (
                                <Box className="al-pagination-bar">
                                    <div className="al-page-size-row">
                                        <span className="al-page-size-label">Rows per page</span>
                                        <Select
                                            options={[
                                                { value: 10, label: '10' }, { value: 25, label: '25' },
                                                { value: 50, label: '50' }, { value: 100, label: '100' },
                                                { value: 200, label: '200' }, { value: 500, label: '500' },
                                            ]}
                                            value={{ value: pageSize, label: pageSize.toString() }}
                                            onChange={(sel) => handlePageSizeChange(sel.value)}
                                            classNamePrefix="al-select"
                                            menuPlacement="top"
                                            styles={{ container: (b) => ({ ...b, minWidth: 80 }) }}
                                        />
                                    </div>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handlePageChange}
                                        variant="outlined"
                                        shape="rounded"
                                        size="small"
                                    />
                                </Box>
                            ),
                        }}
                        loading={loading}
                        sx={{
                            border: 'none',
                            fontFamily: "var(--font-body)",
                            '& .MuiDataGrid-columnHeaders': {
                                color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': { color: '#000', fontSize: '0.88rem' },
                            '& .MuiDataGrid-sortIcon': { color: 'rgb(46 45 45 / 85%)' },
                            '& .MuiDataGrid-menuIconButton': { color: 'rgb(46 45 45 / 85%)' },
                            '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': { color: 'rgba(255,255,255,0.85)' },
                            '& .MuiDataGrid-row': { fontSize: '0.8rem' },
                            '& .MuiDataGrid-row:hover': { backgroundColor: '#eef7fd' },
                            '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#d8f0fa' },
                            '& .MuiDataGrid-cell': { borderColor: '#f0f2f5' },
                            '& .MuiDataGrid-footerContainer': { borderTop: '1px solid #e2e6ef', background: '#f8f9fc' },
                            '& .MuiDataGrid-virtualScroller': { backgroundColor: '#fff' },
                        }}
                    />
                </Box>
            </div>

            {/* ══ IMAGE PREVIEW MODAL ══ */}
            {showModal && (
                <div className="al-modal-backdrop" id="al-modal" onClick={() => setShowModal(false)}>
                    <div className="al-modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="al-modal-header">
                            <div className="al-modal-title">
                                <div className="al-modal-title-icon"><i className="bi bi-image" /></div>
                                <span>{head_title} — Image Preview</span>
                            </div>
                            <div className="al-modal-header-actions">
                                <button className="al-btn al-btn-primary al-btn-sm" onClick={() => handleDownloadFile(imageName, '1')}>
                                    <i className="bi bi-download" /> Download
                                </button>
                                <button className="al-btn al-btn-danger al-btn-sm" onClick={() => setShowModal(false)}>
                                    <i className="bi bi-x-lg" />
                                </button>
                            </div>
                        </div>
                        <div className="al-modal-body">
                            <img src={previewImage} alt="Preview" className="al-modal-img" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssetList;